export type TBizIcon =
	| 'TRASH'
	| 'EDIT'
	| 'ARROW-UP'
	| 'ARROW-DOWN'
	| 'ARROW-LEFT-RIGHT'
	| 'COPY'
	| 'DOWNLOAD'
	| 'REFRESH'
	| 'ADD'
	| 'SAVE'
	| 'STAR_SOLID'
	| 'STAR_LIGHT'
	| 'EXCEL'
	| 'REMOVE'
	| 'CHECK'
	| 'LOADING'
	| 'HOME'
	| 'FOLDER'
	| 'FOLDER_OPEN'
	| 'FLASK'
	| 'VIEW'
	| 'BOOK'
	| 'SCHOOL'
	| 'VIDEO'
	| 'SPELL_CHECK'
	| 'NEWSPAPER'
	| 'IMAGE'
	| 'PAGE'
	| 'SEARCH'
	| 'FILE'
	| 'STOP'
	| 'BELL'
	| 'BELL_SLASH'
	| 'BELL_OUTLINE'
	| 'BELL_SLASH_OUTLINE'
	| 'LOCK'
	| 'INVOICE'
	| 'PDF'
	| 'CHART'
	| 'COMMENT'
	| 'IMPORT'
	| 'LIST'
	| 'SHORTCUT'
	| 'MOVE'
	| 'LINK'
	| 'HISTORY'
	| 'TRIANGLE_EXCLAMATION'
	| 'EYE_SLASH'
	| 'ENVELOPE'
	| 'SHEILD'
	| 'USERS'
	| 'USER'
	| 'UTENSILS'
	| 'GENDER'
	| 'REPLY'
	| 'SETTINGS';

const icons: Record<TBizIcon, string> = {
	EDIT: 'fa-regular fa-edit',
	ADD: 'fa-solid fa-plus',
	TRASH: 'fa-solid fa-trash-alt',
	'ARROW-UP': 'fa-solid fa-arrow-up',
	'ARROW-DOWN': 'fa-solid fa-arrow-down',
	'ARROW-LEFT-RIGHT': 'fa-solid fa-arrow-right-arrow-left',
	COPY: 'fa-regular fa-copy',
	DOWNLOAD: 'fa-regular fa-download',
	REFRESH: 'fa-regular fa-arrows-rotate',
	SAVE: 'fa-solid fa-floppy-disk',
	STAR_SOLID: 'fa-solid fa-star',
	STAR_LIGHT: 'fa-light fa-star',
	REMOVE: 'fa-regular fa-xmark',
	EXCEL: 'fa-regular fa-file-excel',
	CHECK: 'far fa-check',
	LOADING: 'fad fa-spinner-third fa-spin',
	HOME: 'fa-regular fa-house',
	FOLDER: 'fa-solid fa-folder',
	FOLDER_OPEN: 'fa-regular fa-folder-open',
	FLASK: 'fa-solid fa-flask',
	VIEW: 'fa-regular fa-eye',
	BOOK: 'fa-solid fa-book',
	SCHOOL: 'fa-solid fa-school',
	VIDEO: 'fa-solid fa-video',
	SPELL_CHECK: 'fa-solid fa-spell-check',
	NEWSPAPER: 'fa-solid fa-newspaper',
	IMAGE: 'fa-solid fa-image',
	PAGE: 'fa-solid fa-page',
	SEARCH: 'fa-solid fa-search',
	FILE: 'fa-solid fa-file',
	STOP: 'fa-solid fa-stop',
	BELL: 'fa-solid fa-bell',
	BELL_SLASH: 'fa-solid fa-bell-slash',
	BELL_OUTLINE: 'fa-regular fa-bell',
	BELL_SLASH_OUTLINE: 'fa-regular fa-bell-slash',
	LOCK: 'fa-solid fa-lock',
	INVOICE: 'fa-solid fa-file-invoice',
	PDF: 'fa-solid fa-file-pdf',
	CHART: 'fa-solid fa-chart-simple',
	COMMENT: 'fa-solid fa-comment',
	IMPORT: 'fa-solid fa-file-import',
	LIST: 'fa-solid fa-list',
	SHORTCUT: 'fa-sharp fa-regular fa-square-up-right',
	MOVE: 'fa-solid fa-arrows-alt',
	LINK: 'fa-solid fa-link',
	HISTORY: 'fa-solid fa-rectangle-history',
	TRIANGLE_EXCLAMATION: 'fa-solid fa-triangle-exclamation',
	EYE_SLASH: 'fa-solid fa-eye-slash',
	ENVELOPE: 'fa-solid fa-envelope',
	SHEILD: 'fa-duotone fa-solid fa-shield-quartered',
	USERS: 'fa-solid fa-users',
	USER: 'fa-solid fa-user',
	UTENSILS: 'fa-solid fa-utensils',
	GENDER: 'fa-solid fa-venus-mars',
	REPLY: 'fa-solid fa-reply',
	SETTINGS: 'fa-solid fa-gear',
};

export const getIconClassByType = (iconType: TBizIcon) => {
	return icons[iconType];
};

export const BizIcon = ({ icon, className }: { icon: TBizIcon; className?: string }) => {
	return <i className={`biz-icon ${icon.toString().toLowerCase()} ${icons[icon]} ${className ?? ''}`}></i>;
};
